<script>
export default {
    name: 'NavbarComponent'
}
</script>

<template>
    <div>
        <nav class="navbar navbar-expand navbar-dark bg-dark">
            <router-link to="/" class="navbar-brand">PDF Rendering</router-link>
            <div class="navbar-nav mr-auto">
                <li class="nav-item">
                    <router-link to="/monitoring" class="nav-link">Monitoring</router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/administrative" class="nav-link">Administrative</router-link>
                </li>
            </div>
        </nav>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/Navbar.vue